import { styled } from "styled-components";

export const PicksItemCountWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #ccc;
  font-weight: 600;
`;
